import { apiClient } from "../config";
async function getAdminTracking(queryParams: any) {
  const res = await apiClient.get("/admin/trackings", {
    params: queryParams,
  });
  return res.data;
}

export default getAdminTracking;
